import axios from 'axios'

import storage from "@/utils/storage.js";

import i18n from "@/i18n/index.js";

// 导入Element UI消息组件
import {
	Message
} from 'element-ui';

// 默认请求域名
// 在Vue CLI项目中，process.env会被自动注入和替换
const DEFAULT_BASE_URL = process.env.VUE_APP_BASE_API || '/api'

// 创建axios实例工厂函数
const createAxiosInstance = (baseURL = DEFAULT_BASE_URL) => {
	const instance = axios.create({
		baseURL,
		timeout: 60000, // 请求超时时间
		headers: {
			'Content-Type': 'application/json;charset=utf-8'
		}
	})

	// 请求拦截器
	instance.interceptors.request.use(
		config => {
			// 获取accesstoken（优先从localStorage获取，其次从全局参数获取）
			let accessToken = storage.getToken()
			// 判断是否需要传参给accesstoken，未传参则默认为true
			var needAccessToken = config.needAccessToken !== false;
			if (accessToken && needAccessToken) {
				config.headers['accessToken'] = accessToken;
			}

			// 检查是否需要使用表单提交
			if (config.formData) {
				// 设置表单提交的Content-Type
				config.headers['Content-Type'] = 'application/x-www-form-urlencoded';
				// 如果数据是对象，转换为URL编码格式
				if (config.method && ['post', 'put'].includes(config.method.toLowerCase()) && config.data &&
					typeof config.data === 'object') {
					config.data = Object.keys(config.data).map(key => {
						return encodeURIComponent(key) + '=' + encodeURIComponent(config.data[key]);
					}).join('&');
				}
			}

			if (config.clientType) {
				config.headers['clientType'] = "APP";
			}

			return config
		},
		error => {
			console.error('Request error:', error)
			return Promise.reject(error)
		}
	)

	// 响应拦截器
	instance.interceptors.response.use(
		response => {
			const res = response.data;
			if (!res.code) {
				return Promise.resolve(res)
			}
			if(res.code == 10000) {
				Message.error(i18n.t('websiteErr'));
			}
			// 对于外部API，直接返回响应数据
			if (response.config.url && response.config.url.startsWith('http')) {
				return Promise.resolve(res)
			}
			return Promise.resolve(res)
		},
		error => {
			console.error('Response error:', error)
			// 处理401未授权
			if (error.response && error.response.status === 401) {
				// 显示登录失效提示
				Message.error(i18n.t('loginExpired'));
			}
			// 当前请求地址没有权限
			if (error.response && error.response.status === 403) {
				// 显示登录失效提示
				Message.error(i18n.t('loginExpired'));
			}
			return Promise.reject(error)
		}
	)

	return instance
}

// 创建默认axios实例
const defaultInstance = createAxiosInstance()

// 封装请求方法
export default {
	get(url, params = {}, config = {}) {
		let requestUrl = url
		let requestParams = params

		// 如果传入了baseURL，则创建临时实例
		if (config.baseURL) {
			const tempInstance = createAxiosInstance(config.baseURL)
			// 移除baseURL配置，避免传递给axios
			const {
				baseURL: _,
				...axiosConfig
			} = config
			return tempInstance.get(requestUrl, {
				params: requestParams,
				...axiosConfig
			})
		}
		// 否则使用默认实例
		return defaultInstance.get(requestUrl, {
			params: requestParams,
			...config
		})
	},

	post(url, data = {}, config = {}) {
		// 如果传入了baseURL，则创建临时实例
		if (config.baseURL) {
			const tempInstance = createAxiosInstance(config.baseURL)
			// 移除baseURL配置，避免传递给axios
			const {
				baseURL: _,
				...axiosConfig
			} = config
			return tempInstance.post(url, data, axiosConfig)
		}
		// 否则使用默认实例
		return defaultInstance.post(url, data, config)
	},

	put(url, data = {}, config = {}) {
		// 如果传入了baseURL，则创建临时实例
		if (config.baseURL) {
			const tempInstance = createAxiosInstance(config.baseURL)
			// 移除baseURL配置，避免传递给axios
			const {
				baseURL: _,
				...axiosConfig
			} = config
			return tempInstance.put(url, data, axiosConfig)
		}
		// 否则使用默认实例
		return defaultInstance.put(url, data, config)
	},

	delete(url, params = {}, config = {}) {
		// 如果传入了baseURL，则创建临时实例
		if (config.baseURL) {
			const tempInstance = createAxiosInstance(config.baseURL)
			// 移除baseURL配置，避免传递给axios
			const {
				baseURL: _,
				...axiosConfig
			} = config
			return tempInstance.delete(url, {
				params,
				...axiosConfig
			})
		}
		// 否则使用默认实例
		return defaultInstance.delete(url, {
			params,
			...config
		})
	}
}